import React from "react";
import SideBar from "../components/sidebar/sidebar";
import MainContent from "../components/main/mainContent";
import Details from "../components/details/details";
import SystemCheck from "../components/system_check/system_check";
import Authentication from "../components/authentication/authentication";
import Environment from "../components/environment/environment";
import Instrucions from "../components/instructions/instructions";
import Agreement from "../components/aggrement/aggrement";
import CandidatePrivateRoute from "../privateRoutes/candidatePrivateRoute";
import FacialAuthenticationPrivateRoute from "../privateRoutes/FacialAuthenticationPrivateRoute";
import { Route, Switch, Redirect } from "react-router-dom";
import Framelist from "../components/framelist/framelist";
import { pathArray } from "../utils/utils";

const ProtectedAuthenticationPage = (props) => (
  <CandidatePrivateRoute {...props} component={Authentication} />
);
function CandidateAuthPage() {
  return (
    <div className="position-relative">
      <SideBar>
        <Framelist style={{ marginTop: 125 }} />
      </SideBar>
      <MainContent>
        <Switch>
          <Route exact path={`/`} component={Details} />
          <CandidatePrivateRoute
            exact
            path={`/${pathArray[1]}`}
            component={SystemCheck}
          />
          <FacialAuthenticationPrivateRoute
            exact
            path={`/${pathArray[2]}`}
            component={ProtectedAuthenticationPage}
          />
          <CandidatePrivateRoute
            exact
            path={`/${pathArray[3]}`}
            component={Environment}
          />
          <CandidatePrivateRoute
            exact
            path={`/${pathArray[4]}`}
            component={Instrucions}
          />
          <CandidatePrivateRoute
            exact
            path={`/${pathArray[5]}`}
            component={Agreement}
          />
          <Route path="/">
            <Redirect to="/" />
          </Route>
        </Switch>
      </MainContent>
    </div>
  );
}

CandidateAuthPage.propTypes = {};

export default CandidateAuthPage;
